export function getView(patient_id) {
  return !patient_id ? 'PatientSelect' : 'PatientPreview'
}
